const {
	required,
	maxLength,
	minLength,
	email,
	helpers,
} = require("vuelidate/lib/validators");

export const getValidations = () => {
	return {
		eval: {
			name: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
			email: {
				required,
				email,
				alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
				maxLength: maxLength(320), // Total length limit
				localPartMaxLength: (value) => {
					if (value) {
						const localPart = value.split("@")[0];
						return localPart.length <= 64; // Local part length limit
					}
					return true; // Allow empty value
				},
			},
			phoneNumber: {
				required,
				minLength: minLength(10),
				maxLength: maxLength(10),
				alpha: helpers.regex("alpha", /^[6-9]\d{9}$/),
			},
		},
		aoeoptiontags: {
			required,
		},
		skilloptionstag: {
			required,
		},
	};
};
